import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  DocumentSummaryStartMutation,
  DocumentSummaryStartMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { documentSummaryCachedQueryKey } from "./useDocumentSummaryCached";

const documentSummaryStartMutation = graphql(`
  mutation documentSummaryStart($documentId: String!) {
    documentSummaryStart(documentId: $documentId) {
      operationId
      status
    }
  }
`);

export function useDocumentSummaryStart(
  options?: UseMutationOptions<
    DocumentSummaryStartMutation,
    ClientError,
    DocumentSummaryStartMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  return useGraphQlMutation(documentSummaryStartMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      // The cached query never refetches on its own, so this is how it learns the run started
      // and turns the subscription on.
      queryClient.setQueryData(documentSummaryCachedQueryKey(variables.documentId), {
        documentSummaryCached: {
          operationId: data.documentSummaryStart.operationId,
          status: "running",
          result: null,
        },
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
}
